import type { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { DELETE_WARBOX_CONVERSATION } from '../constants/actions';
import type { TWarboxConversationActionTypes } from '../types';

/**
 * Deletes a conversation.
 * Backend route expected: DELETE /conversations/:conversationId/delete
 */
export const deleteConversation = async (
    dispatch: Dispatch<TWarboxConversationActionTypes>,
    conversationId: string
): Promise<void> => {
    dispatch({ type: SET_LOADING });
    try {
        await ApiV2.delete(
            `/conversations/${conversationId}/delete`,
            HEADERS()
        );

        dispatch({
            type: DELETE_WARBOX_CONVERSATION,
            payload: { conversationId },
        });
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
        throw error;
    }
};
